import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import scss from './CustomerInfo.module.scss';

const CustomerInfo = () => {
  const { t } = useTranslation('customers');

  const customerInfo = useSelector((state) => state.customers.customerInfo);

  return (
    <div className={scss.infoWrapper}>
      <div className={scss.infoRow}>
        <span className={scss.title}>{`${t('name')}:`} </span>
        <span className={scss.content}>{customerInfo.companyName}</span>
      </div>

      <div className={scss.infoRow}>
        <span className={scss.title}>ID:</span>
        <span className={scss.content}>{customerInfo.id}</span>
      </div>
    </div>
  );
};

export default CustomerInfo;
